import {
  kickBlue,
  kickLightBlue,
  kickNavy,
  kickRed,
} from "~/shared/styles/baseStyles";

export const medicationButtonStyles = {
  minHeight: 44,
  px: 2.5,
  borderRadius: "6px",
  fontSize: "15px",
  textTransform: "none",
  fontWeight: 600,
  lineHeight: 1.4,
  "&.Mui-focusVisible": { outline: `2px solid ${kickBlue}`, outlineOffset: 3 },
};

export const medicationSecondaryButtonStyles = {
  ...medicationButtonStyles,
  color: kickBlue,
  borderColor: "#d7d3e5",
  "&:hover": { borderColor: kickBlue, backgroundColor: kickLightBlue },
};

export const medicationPrimaryButtonStyles = {
  ...medicationButtonStyles,
  backgroundColor: kickRed,
  color: "#fff",
  "&:hover": { backgroundColor: "#d94b26" },
};

export const medicationInputStyles = {
  "& .MuiOutlinedInput-root": {
    backgroundColor: "#fff",
    borderRadius: "6px",
    color: kickNavy,
    fontSize: "16px",
    lineHeight: 1.6,
    "& fieldset": { borderColor: "#d7d3e5" },
    "&:hover fieldset": { borderColor: "#9490b6" },
    "&.Mui-focused fieldset": { borderColor: kickBlue },
  },
  "& .MuiInputBase-input::placeholder": { color: "#77778a", opacity: 1 },
};

export const medicationHeadingStyles = {
  fontFamily: '"Spectral-SemiBold", "Spectral", Georgia, serif',
  color: kickNavy,
  fontSize: { xs: "22px", sm: "24px" },
  lineHeight: 1.3,
  m: 0,
};
